// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.db9e00 {
  height: 100%;
  overflow: auto;
}
.ce466e {
  overflow: unset;
}`, "",{"version":3,"sources":["webpack://./node_modules/@hm-group/fabric-components/dist/esm/brand/hm/helpers/FocusTrap/FocusTrap.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,eAAe;AACjB","sourcesContent":[".db9e00 {\n  height: 100%;\n  overflow: auto;\n}\n.ce466e {\n  overflow: unset;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
